export default __webpack_public_path__ + "e5a627ad7eaedfb98b6ed5861b42967d.png";